module.exports = __webpack_public_path__ + "static/color-flush-UWlogo-print-f45f8d6d3892db694d8f35da04314bd1.png";